import RelatedQuestionTooltip from './RelatedQuestionTooltip';

export default RelatedQuestionTooltip;
